import type { UUID } from 'node:crypto';
import type { IAuthClientGetLinksResponse } from '@4dk.dto/kit/services/auth';
import { useUserStore } from './UserStore';
import { LocationHelper } from '~/shared/lib/helpers/LocationHelper';
import { AuthService } from '@/app/services/AuthService';

export const useAuthStore = defineStore('auth', () => {
  const service = new AuthService();
  const _serviceId: UUID = '7dd96658-c26f-42a4-bc55-d8089afef6bf';
  const userStore = useUserStore();
  const isLoggedIn = ref(false);
  const sessionInit = ref(false);
  const authLinks = reactive<IAuthClientGetLinksResponse>({
    login_url: '',
    logout_url: '',
  });

  const setAuthLinks = async () => {
    const pathname = LocationHelper.getPathname();
    await service.getAuthLinks({ service_id: _serviceId, redirect_uri: pathname }).then((response) => {
      authLinks.login_url = response.data.login_url;
      authLinks.logout_url = response.data.logout_url;
    });
  };

  const setSession = async (session: string, code: string, passEntrance: boolean) => {
    const pathname = LocationHelper.getPathname();
    return await service
      .getSession({
        fetch_access_roles: true,
        fetch_profile_data: true,
        service_id: _serviceId,
        redirect_uri: pathname,
        pass_entrance: passEntrance,
        session_state: session,
        code,
      })
      .then((user) => {
        sessionInit.value = true;
        isLoggedIn.value = true;
        userStore.setUser(user.data);
        return true;
      });
  };

  const getCurrentAccount = async () => {
    // const hasCookie = import.meta.client ? true : useRequestHeaders(['cookie'])
    await service
      .getCurrent()
      .then((response) => {
        isLoggedIn.value = true;
        userStore.setUser(response.data);
        return true;
      })
      .catch(() => {
        userStore.unsetUser();
        isLoggedIn.value = false;
        return false;
      });
  };

  const logout = async () => {
    userStore.unsetUser();
    isLoggedIn.value = false;
    await setAuthLinks();
    return navigateTo(authLinks.logout_url, { external: true });
  };

  return {
    isLoggedIn,
    authLinks,
    setAuthLinks,
    setSession,
    getCurrentAccount,
    logout,
  };
});
